import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import TaskModalFile from './files_section_file';
import Util from '../../../util/util';
import {fileVisibility, referenceSitesForTask} from '../inlineImages/references';

/**
 * One list from the task's own uploads and the files linked from the project. Kept as two GraphQL
 * connections so neither side changes shape, and merged here because the user does not care how a
 * file arrived — except that removing a linked file must detach it rather than delete it, which is
 * what isProjectFile carries.
 */
export function mergeTaskFiles(files, referencedFiles) {
	const uploaded = ((files && files.edges) || [])
		.filter(edge => edge && edge.node)
		.map(edge => ({...edge.node, isProjectFile: false}));
	const linked = ((referencedFiles && referencedFiles.edges) || [])
		.filter(edge => edge && edge.node)
		.map(edge => ({...edge.node, isProjectFile: true}));
	return [...uploaded, ...linked];
}

class FilesSection extends Component {
	render() {
		const {task, isTaskReadOnly} = this.props;
		const {files, referencedFiles, googleDriveFiles} = task;
		// getFilesPreviewableMap reads files.edges, so the merged list is handed back in connection
		// shape rather than as a plain array. isProjectFile rides along on each node.
		const allFiles = mergeTaskFiles(files, referencedFiles);
		const filesPreviewMap = Util.getFilesPreviewableMap({edges: allFiles.map(node => ({node}))});

		if (task.files == null || googleDriveFiles == null) {
			return <div className={'error-files-empty'} />;
		}

		// An image placed in the text is owned by the text, so it is not offered here
		// as a separate attachment to delete — see fileVisibility for the full rule.
		const referenceSites = referenceSitesForTask(task);
		const visibleFiles = (filesPreviewMap || [])
			.filter(fp => fp.file)
			.map(fp => ({...fp, ...fileVisibility(fp.file.id, referenceSites)}))
			.filter(fp => fp.visible);

		//Don't render the section if there are no files
		if (visibleFiles.length < 1 && !googleDriveFiles.edges.length) return null;

		return (
			<div className="task-modal-v3-files-section" data-cy="task-modal-files-section">
				<div className="files-section-content">
					<div className="files-list" data-cy="task-modal-files-list">
						{visibleFiles.map(fp => (
							<TaskModalFile
								key={fp.file.id}
								isTaskReadOnly={isTaskReadOnly}
								file={fp.file}
								task={task}
								showPreview={fp.showPreview}
								canDelete={fp.canDelete}
								isProjectFile={fp.file.isProjectFile}
							/>
						))}
						{googleDriveFiles.edges.map(fileEdge => (
							<TaskModalFile
								key={fileEdge.node.id}
								isTaskReadOnly={isTaskReadOnly}
								file={fileEdge.node}
								task={task}
								gDriveFile={true}
							/>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(FilesSection);
